/**
 * Componente: Zona imprimible de la credencial.
 * Oculta en pantalla normal (ver .zona-imprimible en padron.css) — solo
 * se vuelve visible dentro de @media print, momento en el que el resto de
 * la página se oculta entera (visibility:hidden en body *) para que lo
 * único que salga en la hoja impresa sea esto. El tamaño físico exacto de
 * la tarjeta (85.6mm x 53.98mm) lo define @page en el CSS, no acá.
 *
 * Usa LicenseCard con paraImpresionFisica={true} — igual que antes hacía
 * generarPDFLicencia.js, así que nunca pinta el fondo preimpresa (ver la
 * regla de negocio en LicenseCard.jsx). Cada cara en su propio
 * contenedor (.zona-imprimible-cara) para poder mandarlas a páginas
 * separadas con page-break-after cuando el diseño es doble cara.
 */

import React, { forwardRef } from 'react';
import LicenseCard from './LicenseCard';

const ZonaImprimible = forwardRef(({ contribuyente, diseno }, ref) => {
  const esDobleCara = diseno.tipo_impresion === 'doble_cara';

  return (
    <div ref={ref} className="zona-imprimible">
      <div className="zona-imprimible-cara">
        <LicenseCard contribuyente={contribuyente} diseno={diseno} cara="frente" paraImpresionFisica />
      </div>
      {esDobleCara && (
        <div className="zona-imprimible-cara">
          <LicenseCard contribuyente={contribuyente} diseno={diseno} cara="dorso" paraImpresionFisica />
        </div>
      )}
    </div>
  );
});

export default ZonaImprimible;
